import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Diploma = function Diploma(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$secondaryColor = _ref.secondaryColor,
    secondaryColorProp = _ref$secondaryColor === void 0 ? '#6F4EF6' : _ref$secondaryColor,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  var secondaryColor = !ignoreColor ? secondaryColorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M12.6665 9.33325H4.6665V7.99992H11.3332V1.33325H12.6665V9.33325Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M28 28.0001H22V26.6667H26.6667V2.00008H12.275L5.33333 8.94175V26.6667H16V28.0001H4V8.39175L11.725 0.666748H28V28.0001Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M19.0002 25.3333C17.8794 25.3333 16.7838 25.001 15.8519 24.3783C14.9201 23.7557 14.1937 22.8707 13.7648 21.8352C13.336 20.7998 13.2237 19.6604 13.4424 18.5612C13.661 17.4619 14.2007 16.4522 14.9932 15.6597C15.7857 14.8672 16.7954 14.3275 17.8947 14.1089C18.9939 13.8902 20.1333 14.0025 21.1687 14.4314C22.2042 14.8602 23.0892 15.5866 23.7118 16.5184C24.3345 17.4503 24.6668 18.5459 24.6668 19.6667C24.6646 21.1689 24.0669 22.6089 23.0047 23.6712C21.9424 24.7334 20.5024 25.3311 19.0002 25.3333ZM19.0002 15.3333C18.1431 15.3333 17.3053 15.5875 16.5927 16.0636C15.8801 16.5398 15.3247 17.2166 14.9967 18.0084C14.6687 18.8002 14.5829 19.6715 14.7501 20.5121C14.9173 21.3526 15.33 22.1248 15.936 22.7308C16.5421 23.3368 17.3142 23.7495 18.1548 23.9167C18.9954 24.0839 19.8666 23.9981 20.6585 23.6701C21.4503 23.3422 22.127 22.7868 22.6032 22.0741C23.0794 21.3615 23.3335 20.5237 23.3335 19.6667C23.3313 18.5181 22.874 17.4172 22.0619 16.605C21.2497 15.7928 20.1488 15.3355 19.0002 15.3333Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M22.6668 31.5334L19.0002 29.9084L15.3335 31.5334V23.6667H16.6668V29.4834L19.0002 28.4501L21.3335 29.4834V23.6667H22.6668V31.5334Z",
      fill: secondaryColor
    })]
  });
};
export default Diploma;